import { IWPImage, IWPLink } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type IBlogData = {
  allWpBlog: {
    nodes: {
      title: string;
      uri: string;
      date: string;
      blogInfo: {
        featuredImage: IWPImage;
        author: {
          staffInfo: {
            firstName: string;
            lastName: string;
          };
        };
      };
    }[];
  };
};

const useBlogData = () => {
  const { allWpBlog }: IBlogData = useStaticQuery(graphql`
    {
      allWpBlog(sort: { date: DESC }) {
        nodes {
          title
          uri
          date(formatString: "D MMM YYYY")

          blogInfo {
            featuredImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 400
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }

            author {
              ... on WpStaff {
                staffInfo {
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  `);

  return allWpBlog.nodes;
};

export default useBlogData;
